module.exports = __webpack_public_path__ + "static/icons/icon-user-4976497bf7c82e409d6e41c4fe82323a.svg";